import React, { useState, Component, Fragment } from "react"
import { accessRole } from "../../../../../../helpers/access_role"
import { config } from "../../../../../../helpers/config_global"
import { Redirect } from "react-router-dom"

import { Tooltip, Label } from "reactstrap"
import MKIDatatable from '../../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/homeService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../../services/apiResponse'
import moment from "moment"

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    historyTable = 'historyPerjaDinasTableActive'
    defaultOrder = 'official_travel_start_date'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            approveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: false,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            date_start: this.props.filter?.dateStart,
            date_end: this.props.filter?.dateEnd,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        // this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

    }

    // componentDidUpdate(prevProps, prevState) {
    //     if (prevProps.filter !== this.props.filter) {
    //         this.loadData()
    //     }
    // }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
    }

    columns = [
        {
            key: "official_travel_number",
            text: "Nomor ST",
            sortable: true,
            width: '80'
        },
        {
            key: "participant",
            text: "Partisipan",
            sortable: true,
            width: '20%',
            cell: record => {
                let res = "-";
                res = <label>{record.participant?.length ? record.participant?.length : 0} Personil</label>

                // record.participant.forEach(el => {
                //     res += <p>{el.employee.employee_name}</p>
                // });

                return res;
            } 
        },
        {
            key: "official_travel_domicile",
            text: "Tujuan",
            sortable: true,
            cell: record => {
                return (
                    <span>
                        <Fragment>
                            <Label>{record.official_travel_case_name}</Label> <br/>
                        </Fragment>                        
                        {record.official_travel_province && record.official_travel_oversea == 1 &&
                            <Fragment>
                                <Label>Provinsi: {record.official_travel_province}</Label> <br/>
                            </Fragment>
                        }
                        {record.official_travel_city && record.official_travel_oversea == 1 &&
                            <Fragment>
                                <Label>Kota: {record.official_travel_city}</Label> <br/>
                            </Fragment>
                        }
                        {record.official_travel_destination && record.official_travel_oversea == 1 &&
                            <Label>Tempat: {record.official_travel_destination}</Label>
                        }
                    </span>
                )
            }
        },
        {
            key: "official_travel_start_date",
            text: "Tanggal Mulai",
            sortable: true,
            cell: record => {
                return reformatDate(record.official_travel_start_date)
            }
        },
        {
            key: "official_travel_end_date",
            text: "Tanggal Selesai",
            sortable: true,
            cell: record => {
                return reformatDate(record.official_travel_end_date)
            }
        },
        {
            key: "official_travel_description",
            text: "Keterangan",
            sortable: true,
        },
        {
            key: "official_travel_approval_status",
            text: "Status",
            className: "need_approval",
            sortable: true,
            align: 'center',
            width: 120,
            cell: record => {
                var need_approval = record.official_travel_approval_status
                return (
                    <span>
                        { need_approval == 0 &&
                            <label className="badge rounded-pill bg-soft-warning font-size-12" >Menunggu Approval</label>
                        }
                        { need_approval == 1 &&
                            <label className="badge rounded-pill bg-soft-success font-size-12" >Disetujui</label>
                        }
                        { need_approval == 2 &&
                            <label className="badge rounded-pill bg-soft-info font-size-12" >Ditolak</label>
                        }
                    </span>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.official_travel_id
                return (
                    <Fragment>
                        { record.official_travel_approval_status === 0 && 
                            <Fragment>
                                {accessRole('approve') &&
                                    <span>
                                        <button
                                            className="btn btn-success btn-sm"
                                            id={"approve-"+thisId}
                                            onClick={() => {
                                                this.setState({
                                                    approveUuid: record.official_travel_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-check"></i>
                                        </button>
                                    </span>
                                }
                            </Fragment>
                        }
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.official_travel_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Lihat</Tooltip>
                        </span>
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.approveUuid !== null ?
                    <Redirect to={`/izinpegawai/dinas.html?approve&uuid=${this.state.approveUuid}`}/>
                : null }
                { this.state.detailUuid !== null ?
                    <Redirect to={`/izinpegawai/dinas.html?detail&uuid=${this.state.detailUuid}`}/>
                : null }
            </>
        )
    }

}

export default TableActiveComponent